/**
 *
 * Asynchronously loads the component for DashboardPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
